import { render } from "./ProjectAccessComponent.vue?vue&type=template&id=76e32b34"
import script from "./ProjectAccessComponent.vue?vue&type=script&lang=js"
export * from "./ProjectAccessComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__